<script setup lang="ts">
import BaseHeadline from "@/components/Base/Headline.vue";
import FoldersEmptyStateAlert from "@/components/FoldersEmptyStateAlert.vue";
import ListItemList from "@/components/ListItemList/index.vue";
import HomeMoreLink from "@/components/home/MoreLink.vue";
import type { Item } from "@/services/fobizzToolsApi";

defineProps<{ recentlyCreatedItems?: Item[] }>();

const { t } = useI18n();
</script>

<template>
  <div class="d-flex flex-column">
    <BaseHeadline tag="h3" weight="medium" class="mb-2">{{
      t("startPage.headers.myContent")
    }}</BaseHeadline>
    <div
      v-if="recentlyCreatedItems && recentlyCreatedItems.length > 0"
      class="mb-2"
    >
      <ListItemList
        :items="recentlyCreatedItems"
        :invalidate-query-key="['items']"
        :show-middle="false"
        :show-extras="false"
      />
    </div>
    <FoldersEmptyStateAlert
      v-else
      :title="t('folders.hints.noItems.title')"
      :text="t('folders.hints.noItems.text')"
    />
    <HomeMoreLink to="/folders" :title="t('startPage.links.myContent')" />
  </div>
</template>

<style lang="scss" scoped>
.basic-list {
  list-style-type: none;
  padding: 0;
}
</style>
